module.exports = ".referencia {\n    color: #547EC9;\n}\n\n.scroll {\n    height: 100vh;\n    overflow-y: scroll;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal/ajuda-variaveis-modal/ajuda-variaveis-modal.component.css
// module id = ./src/app/modal/ajuda-variaveis-modal/ajuda-variaveis-modal.component.css
// module chunks = main